/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import ArrowDown from "../../styles/default/assets/icons/arrow-down.svg";

const Picker = ({ data, name, value, setValue, components }) => {
  const [canShowList, setShowList] = useState(false);

  return (
    <div
      className='websdk-flex time-picker-pill-web-sdk'
      onClick={() => setShowList(!canShowList)}
    >
      <div className='time-picker-placeholer-web-sdk'>
        <p>{value ? value[name] : `${name}`}</p>
        <components.Icon src={ArrowDown} showIcon={!canShowList} />
      </div>
      {canShowList ? (
        <div
          name={`time-picker-${name}`}
          className='websdk-flex time-picker-list-web-sdk'
        >
          {data?.map((pick, index) => {
            return (
              <div
                className='time-picker-list-item-web-sdk'
                onClick={() => {
                  setValue({ [name]: pick });
                  setShowList(!canShowList);
                }}
                key={index}
              >
                {pick}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

Picker.propTypes = {
  components: PropTypes.arrayOf(PropTypes.node).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  name: PropTypes.string,
  value: PropTypes.objectOf(PropTypes.object).isRequired,
  setValue: PropTypes.func
};

export default Picker;
